import {sumBy} from 'lodash';

import {isRatingListKey, ReviewsStatisticDataType} from '../../../../../service/reviews/reviews-statistic';

export function getRatingListCountForKey(
    ratingList: ReviewsStatisticDataType['ratingList'] | undefined,
    rating: unknown
): number {
    return isRatingListKey(rating) ? ratingList?.[rating] ?? 0 : 0;
}

export function getWeightedAverageRatingForSelectedRatings(
    ratingList: ReviewsStatisticDataType['ratingList'] | undefined,
    selectedRatings: ReadonlyArray<number>,
    globalRatingAvg: number
): number {
    if (!ratingList || selectedRatings.length === 0) {
        return globalRatingAvg;
    }

    const totalCount = sumBy(selectedRatings, (rating) => getRatingListCountForKey(ratingList, rating));

    if (totalCount === 0) {
        return 0;
    }

    const weightedSum = sumBy(selectedRatings, (rating) => rating * getRatingListCountForKey(ratingList, rating));

    return weightedSum / totalCount;
}
